import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, VERSION } from '@angular/core';
import { version as appVersion } from '../../../../package.json';

/**
 * AboutComponent
 *
 * Displays the technical information of the running application: the project
 * version read from `package.json`, the Angular version it is built with, and
 * the exact revision it was built from (see `tools/generate-build-info.mjs`).
 */
@Component({
  selector: 'rk-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  imports: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent {
  /** Version of the project, coming from `package.json`. */
  readonly appVersion: string = appVersion;

  /** Full version of the Angular framework used to build the application. */
  readonly angularVersion: string = VERSION.full;
}
